import { Box } from "@chakra-ui/react";
import { Button } from "pixelize-design-library";
import { useRouteError } from "react-router";
import { ErrorState } from "./ErrorState";

export const RouteErrorPage = () => {
  const error = useRouteError();

  return (
    <Box p={10}>
      <ErrorState
        error={error}
        title="Something went wrong"
        onRetry={() => window.location.reload()}
      />
      <Box mt={6} textAlign="center">
        <Button label="Back to home" variant="ghost" onClick={() => window.location.assign("/")} />
      </Box>
    </Box>
  );
};
